import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  menuPageContainer: {
    width: '100%',
  },
  sectionContentContainer: {
    width: '100%',
  },
}));
